import { modifier } from 'ember-modifier';

/**
 * A modifier that executes a callback function when the element is inserted into the DOM.
 *
 * This replaces the deprecated `did-insert` modifier from @ember/render-modifiers.
 *
 * @example
 * <div {{on-insert this.loadCurrentEmployee}}>
 *   ...
 * </div>
 */
export default modifier(function onInsert(_element: Element, positional: [() => void]) {
  const [callback] = positional;
  callback();
});
